export const ideas = {
  // Page Header
  'ideasProjects': 'Ideas & Projects',
  'captureOrganizeEvolve': 'Capture, organize and evolve your project ideas',
  
  // Stats Cards
  'totalIdeas': 'Total Ideas',
  'thisWeek': 'This Week',
  'ready': 'Ready',
  'archived': 'Archived',
  
  // Search and Filters
  'searchIdeas': 'Search ideas...',
  'kanban': 'Kanban',
  'grid': 'Grid',
  'all': 'All',
  
  // Tabs
  'activeIdeas': 'Active Ideas',
  'recentIdeas': 'Recent',
  'archivedIdeas': 'Archived',
  
  // Empty States
  'noIdeas': 'No ideas',
  'noIdeasFiltered': 'No ideas found with current filters',
  'startCreating': 'Start by creating your first idea',
  
  // Actions
  'confirmDelete': 'Are you sure you want to delete this idea?',
  
  // Kanban Columns
  'ideasColumn': 'Ideas',
  'exploringColumn': 'Exploring',
  'planningColumn': 'Planning',
  'readyColumn': 'Ready',
  'dragIdeasHere': 'Drag ideas here',
  
  // Create Dialog
  'newIdea': 'New Idea',
  'addIdeaBtn': '+ New Idea',
  'title': 'Title',
  'titlePlaceholder': 'What is your idea?',
  'description': 'Description',
  'descriptionPlaceholder': 'Describe your idea in more detail...',
  'category': 'Category',
  'priority': 'Priority',
  'tags': 'Tags',
  'addTag': 'Add tag',
  'tagPlaceholder': 'Add tag...',
  'estimatedEffort': 'Estimated Effort',
  'potentialImpact': 'Potential Impact',
  'feasibility': 'Feasibility',
  'cancel': 'Cancel',
  'create': 'Create Idea',
  'creating': 'Creating...',
  'veryLow': 'Very Low',
  'low': 'Low',
  'medium': 'Medium',
  'high': 'High',
  'veryHigh': 'Very High',
  'easy': 'Easy',
  'possible': 'Possible',
  'difficult': 'Difficult'
};